export default {"src":"/_next/static/media/VZ.e1592264.svg","height":18,"width":18};